/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../variables';
@use '../mixins';

//variables for calc:
$header-height: variables.$header-height;
$page-header-height: variables.$page-header-height;
$page-footer-height: variables.$page-footer-height;
$padding-large: variables.$padding-large;
$padding-large: variables.$padding-large;

.App {
  align-items: stretch;
  background-color: variables.$background-color-body;
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

.wireframe-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: variables.$header-height minmax(0, 1fr);
  gap: 0 0;
  grid-template-areas:
    'header'
    'body-content';
  height: 100%;
}

.body-content {
  display: grid;
  grid-template-columns: variables.$sidebar-width auto variables.$sidebar-width;
  grid-template-rows: minmax(0, 1fr);
  gap: 0 0;
  grid-auto-flow: row;
  grid-template-areas: 'navigation center-content right-content';
  padding: variables.$padding-large;
}

.header {
  grid-area: header;
}

.navigation {
  grid-area: navigation;
  @include mixins.area;
  overflow-y: auto;
}

.center-area {
  display: flex;
  flex-direction: column;
  @include mixins.area;
  margin: 0 variables.$margin-large;
  padding: 0;
}

.area-page-content {
  padding: variables.$padding-large variables.$padding-xlarge;
  overflow-y: auto;
  position: relative;
  flex-grow: 1;
}

.right-content {
  grid-area: right-content;
  @include mixins.area;
  overflow-y: auto;
}
